import React, { useEffect } from "react"
import "../styles/App.scss"
import Chart from "chart.js"

let myChart

const LineChart = ({ value }) => {
  useEffect(() => {
    let ctx = document.getElementById("linechart")
    ctx.height = 110
    ctx.width = 175

    if (typeof myChart !== "undefined") myChart.destroy()

    myChart = new Chart(ctx, {
      type: "line",
      data: {
        labels: [
          "Ene.",
          "Feb.",
          "Mar.",
          "Abr.",
          "May.",
          "Jun.",
          "Jul.",
          "Ago.",
          "Sep.",
          "Oct.",
          "Nov.",
          "Dic.",
        ],
        datasets: [
          {
            label: "Indice de Cumplimiento General: ",
            data: value,
            fill: false,
            borderColor: "#0899ba",
            tension: 0.1,
          },
        ],
      },
      options: {
        legend: {
          display: false,
        },
      },
    })
  }, [myChart])

  return (
    <>
      <div className="elements">
        <div className="chart-container-lines">
          <canvas id="linechart"></canvas>
        </div>
      </div>
    </>
  )
}

export default LineChart
